import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { PromotionalBanner } from '../../../components/promotional-banner';
import { UpgradePlanPromotionalBanner } from '../../../components/upgrade-plan-promotional-banner/upgrade-plan-promotional-banner';
import { EventSourceStrings } from '../../../tracking/tracking-constants';
import { WalletRegistrationOrUpdateButton } from '../../../wallet/components/wallet-registration-or-update-button';

import messages from './messages';

import style from './carriers-page.module.less';

const WalletActionBanner = ({ walletId, shouldModalBeOpenAtStart = false }) => (
  <WalletRegistrationOrUpdateButton
    shouldModalBeOpenAtStart={shouldModalBeOpenAtStart}
    trackingId={EventSourceStrings.SETTINGS_CARRIERS_PAGE_BANNER}
    walletId={walletId}
  >
    {({ openModal, isWalletRegistered, hasWalletUpdate }) => {
      if (!isWalletRegistered) {
        return (
          <PromotionalBanner className={style.banner} promotionalSubheaderMessage={messages.getStartedMessageText}>
            <Button className={style['banner-button']} onClick={openModal} theme='promotional'>
              <FormattedMessage {...messages.getStarted} />
            </Button>
          </PromotionalBanner>
        );
      }
      if (hasWalletUpdate) {
        return (
          <PromotionalBanner className={style.banner} promotionalSubheaderMessage={messages.newCarriersMessageText}>
            <Button className={style['banner-button']} onClick={openModal} theme='promotional'>
              <FormattedMessage {...messages.update} />
            </Button>
          </PromotionalBanner>
        );
      }

      return <UpgradePlanPromotionalBanner promotionalHeaderMessage={messages.upgradePromotionalBannerHeader} />;
    }}
  </WalletRegistrationOrUpdateButton>
);

WalletActionBanner.propTypes = {
  walletId: PropTypes.string,
  shouldModalBeOpenAtStart: PropTypes.bool,
};

export default WalletActionBanner;
